import React from 'react';

function Privacy() {

  return (
    <div style={{
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
      padding: '40px 0'
    }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="text-center mb-5">
              <h1 className="display-4 fw-bold text-primary mb-3">
                <i className="fas fa-shield-alt text-warning me-3"></i>
                Política de Privacidad
              </h1>
              <p className="lead text-muted">
                Tu privacidad es importante para nosotros. Conoce cómo protegemos tu información.
              </p>
              <p className="text-muted small">
                Última actualización: {new Date().toLocaleDateString('es-ES')}
              </p>
            </div>

            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row">
                  <div className="col-lg-3">
                    <nav className="nav flex-column nav-pills">
                      <a className="nav-link active" href="#coleta">Recopilación de Datos</a>
                      <a className="nav-link" href="#uso">Uso de la Información</a>
                      <a className="nav-link" href="#compartilhamento">Compartición</a>
                      <a className="nav-link" href="#seguranca">Seguridad</a>
                      <a className="nav-link" href="#cookies">Cookies</a>
                      <a className="nav-link" href="#direitos">Tus Derechos</a>
                      <a className="nav-link" href="#contato">Contacto</a>
                    </nav>
                  </div>
                  
                  <div className="col-lg-9">
                    <div id="coleta" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-database me-2"></i>
                        Recopilación de Datos
                      </h3>
                      <p>Recopilamos la siguiente información cuando usas nuestro sitio:</p>
                      <ul>
                        <li><strong>Información personal:</strong> Nombre, email, dirección, teléfono</li>
                        <li><strong>Información de pedido:</strong> Productos comprados, historial de compras</li>
                        <li><strong>Información técnica:</strong> IP, tipo de navegador, páginas visitadas</li>
                        <li><strong>Cookies:</strong> Para mejorar tu experiencia de navegación</li>
                      </ul>
                    </div>

                    <div id="uso" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-cogs me-2"></i>
                        Cómo Usamos tu Información
                      </h3>
                      <p>Utilizamos tu información para:</p>
                      <ul>
                        <li>Procesar y entregar tus pedidos</li>
                        <li>Comunicar sobre pedidos y promociones</li>
                        <li>Mejorar nuestros productos y servicios</li>
                        <li>Prevenir fraudes y garantizar seguridad</li>
                        <li>Cumplir obligaciones legales</li>
                      </ul>
                    </div>

                    <div id="compartilhamento" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-share-alt me-2"></i>
                        Compartición de Datos
                      </h3>
                      <p>No vendemos, alquilamos ni compartimos tu información personal con terceros, excepto:</p>
                      <ul>
                        <li>Con proveedores de servicios esenciales (entregas, pagos)</li>
                        <li>Cuando lo exige la ley u orden judicial</li>
                        <li>Con tu consentimiento explícito</li>
                        <li>Para proteger nuestros derechos y seguridad</li>
                      </ul>
                    </div>

                    <div id="seguranca" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-lock me-2"></i>
                        Seguridad de los Datos
                      </h3>
                      <p>Implementamos medidas de seguridad robustas para proteger tu información:</p>
                      <ul>
                        <li>Criptografía SSL para transmisión de datos</li>
                        <li>Almacenamiento seguro en servidores protegidos</li>
                        <li>Control de acceso restringido a los datos</li>
                        <li>Monitoreo continuo de seguridad</li>
                        <li>Backups regulares y seguros</li>
                      </ul>
                    </div>

                    <div id="cookies" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-cookie-bite me-2"></i>
                        Uso de Cookies
                      </h3>
                      <p>Utilizamos cookies para:</p>
                      <ul>
                        <li>Recordar tus preferencias de inicio de sesión</li>
                        <li>Analizar el tráfico del sitio</li>
                        <li>Personalizar contenido y anuncios</li>
                        <li>Mejorar la funcionalidad del sitio</li>
                      </ul>
                      <p>Puedes controlar el uso de cookies a través de las configuraciones de tu navegador.</p>
                    </div>

                    <div id="direitos" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-user-check me-2"></i>
                        Tus Derechos
                      </h3>
                      <p>Tienes los siguientes derechos:</p>
                      <ul>
                        <li><strong>Acceso:</strong> Solicitar copia de tus datos personales</li>
                        <li><strong>Corrección:</strong> Solicitar corrección de datos incorrectos</li>
                        <li><strong>Eliminación:</strong> Solicitar eliminación de tus datos</li>
                        <li><strong>Portabilidad:</strong> Recibir tus datos en formato estructurado</li>
                        <li><strong>Oposición:</strong> Oponerte al procesamiento de tus datos</li>
                        <li><strong>Retirada:</strong> Retirar consentimiento en cualquier momento</li>
                      </ul>
                    </div>

                    <div id="contato" className="mb-5">
                      <h3 className="fw-bold text-primary mb-3">
                        <i className="fas fa-envelope me-2"></i>
                        Contactanos
                      </h3>
                      <p>Para ejercer tus derechos o aclarar dudas sobre esta política:</p>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="card bg-light">
                            <div className="card-body">
                              <h6 className="fw-bold">Email</h6>
                              <p className="mb-0">privacidad@luallena.com</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="card bg-light">
                            <div className="card-body">
                                                         <h6 className="fw-bold">Teléfono</h6>
                           <p className="mb-0">+595 981 234 567</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="alert alert-info">
                      <h6 className="fw-bold">
                        <i className="fas fa-info-circle me-2"></i>
                        Importante
                      </h6>
                      <p className="mb-0">
                        Esta política puede ser actualizada periódicamente. Recomendamos que la revises regularmente para mantenerte informado sobre cómo protegemos tu información.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
